<template>
  <FreeModal :name="name" class="text-center" persistent>
    <template #header>
      <h2 class="text-text-neutral-primary text-lg font-semibold">
        {{ title }}
      </h2>
    </template>
    <template #default="{ hide }">
      <div class="mt-1 space-y-6">
        <p class="text-text-neutral-tertiary text-sm font-medium">
          {{ message }}
        </p>
        <div class="space-y-3">
          <FreeButton type="button" class="gray-button w-full" @click="hide">
            {{ $t('general.ok') }}
          </FreeButton>
        </div>
      </div>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FreeModal, FreeButton } from 'freedom-shared';
  import { controllerModel } from 'shared';

  const props = defineProps<{
    name: string;
  }>();

  const { t } = useI18n();
  const modal = controllerModel.useModal();
  const modalParams = computed(() => modal.getParams(props.name));

  const title = computed(
    () => modalParams.value?.title || t('passengersData.saveError.title'),
  );

  const message = computed(
    () =>
      modalParams.value?.message || t('passengersData.saveError.description'),
  );
</script>
